import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-2 bg-white flex flex-col text-12px xxl:text-14px overflow-scroll h-screen relative w-full" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionDeliveryDetail = _resolveComponent("SectionDeliveryDetail")!
  const _component_SectionItemDetail = _resolveComponent("SectionItemDetail")!
  const _component_SectionPaymentDetail = _resolveComponent("SectionPaymentDetail")!
  const _component_CardStatusClaim = _resolveComponent("CardStatusClaim")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      error: !!_ctx.errorCause,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetailClaimData,
      title: _ctx.getTitle,
      "vertical-separator": false
    }, {
      data: _withCtx(() => [
        _createVNode(_component_SectionDeliveryDetail, { detailData: _ctx.dataDetail }, null, 8, ["detailData"]),
        _hoisted_2,
        _createVNode(_component_SectionItemDetail, { detailData: _ctx.dataDetail }, null, 8, ["detailData"]),
        _hoisted_3,
        _createVNode(_component_SectionPaymentDetail, { detailData: _ctx.dataDetail }, null, 8, ["detailData"])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_CardStatusClaim, { detailData: _ctx.dataDetail }, null, 8, ["detailData"])
      ]),
      _: 1
    }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain", "title"])
  ]))
}